import { Component } from '@angular/core';

@Component({
  selector: 'who-is-it-for',
  standalone: true,
  imports: [],
  templateUrl: './who-is-it-for.component.html',
  styleUrl: './who-is-it-for.component.scss'
})
export class WhoIsItForComponent {

}
